import React from "react";
import { Card } from "primereact/card";
import { Link, useLocation, useParams } from "react-router-dom";
import { useOfficerDetails } from "./OfficerDetails";
import ReactCountryFlag from "react-country-flag";
import { getName } from "country-list";
import { Skeleton } from "primereact/skeleton";

const OfficersSideBar = ({ type }) => {
  const location = useLocation();
  const { id: officerId } = useParams();
  const activeTab = location.pathname.split("/")[3] || "info";
  const { regData, loading } = useOfficerDetails();

  const getInitials = (fullName) => {
    const nameArray = fullName.split(" ");
    const firstInitial = nameArray[0] ? nameArray[0].charAt(0) : "";
    const lastInitial =
      nameArray.length > 1 ? nameArray[nameArray.length - 1].charAt(0) : "";
    return `${firstInitial}${lastInitial}`.toUpperCase();
  };

  return (
    <>
      <Card className="officer-details-card">
        <div className="flex flex-column officer-profile">
          <div className="avatar-container mb-3">
            <h3>{getInitials(`${regData.name} ${regData.last_name}`)}</h3>
          </div>
          <p className="officer-details-heading">
            {regData.name} {regData.last_name}
          </p>
          <p className="input-label m-0">
            {type === "officer" ? "Officer" : "Attorney"}
          </p>
          {!loading ? (
            <p className="m-0">
              {regData.entityData?.name} (
              <ReactCountryFlag
                countryCode={regData.entityData?.country}
                svg
                className=""
              />{" "}
              {getName(regData.entityData?.country || "")})
            </p>
          ) : (
            <Skeleton width="150px" height="20px" className="mr-1" />
          )}
        </div>
        <div className="flex flex-column gap-1">
          <Link
            to={
              type === "officer"
                ? `/officers/${officerId}/info`
                : `/powers-of-attorney/${officerId}/info`
            }
            className={`sidebar-align ${activeTab === "info" ? "active-tab" : "menu-hover"}`}
          >
            <p className="sidebar-menu">Personal Information</p>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
          <Link
            to={
              type === "officer"
                ? `/officers/${officerId}/attachments`
                : `/powers-of-attorney/${officerId}/attachments`
            }
            className={`sidebar-align ${activeTab === "attachments" ? "active-tab" : "menu-hover"}`}
          >
            <p className="sidebar-menu">Attachments</p>
            <span className="pi pi-angle-right icon-color"></span>
          </Link>
        </div>
      </Card>
    </>
  );
};

export default OfficersSideBar;
